import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import http from "@core/fetch";
import { FoodProfileDocuments, IFoodProfileDocuments } from "@models/FoodProfileDocuments";


async function getFoodProfileDocuments(word: string): Promise<IFoodProfileDocuments> {
    const result: components["schemas"]["FoodProfileDocumentsDataViewModel"] = await http.get('get food profile documents',{ word });

    return new FoodProfileDocuments({ apiModel: result, query: word });
}

const idleFetchFn = (_word: string | null) => Promise.resolve(new FoodProfileDocuments());

export function useFoodProfileDocuments(word: string) {
    const fetchFn = word
        ? getFoodProfileDocuments
        : idleFetchFn;

    return useData(
        new FoodProfileDocuments(),
        fetchFn,
        word
    );
}